export { default } from "./HeroFifty";
export * from "./HeroFifty";
export * from "./HeroFifty.model";
